/**
 * Small pure presentation helpers for the Change salary dialog and the
 * salary-history card: notice formatting and failure -> copy-key mapping.
 */
import { format_date } from '../../lib/format';
import type {
  AffectedPayRun,
  CompensationMutationFailure,
} from '../../data/use_employee_compensation';

const EN_DASH = '–';

/** `01 Aug 2026 – 31 Aug 2026, 01 Sep 2026 – 30 Sep 2026` (en-GB) for the back-pay notice. */
export function formatBackPayPeriods(
  runs: readonly AffectedPayRun[],
  locale: string,
): string {
  return runs
    .map(
      (run) =>
        `${format_date(run.period_start, locale)} ${EN_DASH} ${format_date(run.period_end, locale)}`,
    )
    .join(', ');
}

/** The title key for a conflict warning: the draft-run case has its own, clearer heading. */
export function conflictTitleKey(
  failure: Extract<CompensationMutationFailure, { kind: 'conflict' }>,
): string {
  return failure.reason === 'draft_overlap'
    ? 'employees.compensation_draft_conflict_title'
    : 'employees.compensation_conflict_title';
}

/** Whether resubmitting with `replace_same_date` can resolve this failure. */
export function isSameDateConflict(
  failure: CompensationMutationFailure | null,
): boolean {
  return failure?.kind === 'conflict' && failure.reason === 'same_date';
}
